import { logError } from "@faire/web--source/common/logging";
export var logPOSError = function(err, fingerPrint) {
    logError(err, {
        fingerprint: [
            "RETAILER-POS",
            fingerPrint
        ]
    });
};
